import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import BasicDataPod from '../../../components/BasicDataPod';
import Value from '../../../components/BasicDataPod/Value';
import Link from '../../../components/BasicDataPod/Link';

const TransferScholarshipsAvailable = ({ transferAdmissions }) => {
  const value = get(transferAdmissions, 'scholarshipsAvailable.value');
  const lastUpdated = get(transferAdmissions, 'lastUpdated.value');
  return value ? (
    <BasicDataPod
      header={`Scholarships Available for Transfer Students`}
      footer={lastUpdated}
      ariaLabel={`Scholarships Available for Transfer Students, ${value}`}
    >
      <div className="number-pod-value-container">
        <Value value={`✓`} />
      </div>
      <Link linkText={`Learn more about financial aid`} linkUrl="Costs#financialaid" />
    </BasicDataPod>
  ) : null;
};

TransferScholarshipsAvailable.propTypes = {
  transferAdmissions: PropTypes.object,
};

export default TransferScholarshipsAvailable;
